import React from 'react';

const InfoIcon: React.FC = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8533_2433)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.66683 11.3335V6.66683V11.3335ZM7.66683 5.3335V4.00016V5.3335ZM7.66683 15.0002C11.7169 15.0002 15.0002 11.7169 15.0002 7.66683C15.0002 3.61674 11.7169 0.333496 7.66683 0.333496C3.61674 0.333496 0.333496 3.61674 0.333496 7.66683C0.333496 11.7169 3.61674 15.0002 7.66683 15.0002Z"
          stroke="#333333"
        />
      </g>
      <defs>
        <clipPath id="clip0_8533_2433">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InfoIcon;
